/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, PaginationStd, ReactCalendar, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { Helper, JobFilterRequestDto, JobService, SeasonDto } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'



const JobPage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [totalRow, setTotalRow] = useState(0)
    const [data, setData] = useState<string[][]>([])
    const [sumData, setSumData] = useState<string[][]>([])
    const [footData, setFootData] = useState<string[][]>([])

    const [searchParam, setSearchParam] = useState<JobFilterRequestDto>({
        startDate: lastSeason.periodStart,
        endDate: lastSeason.periodEnd,
        page: 0,
        length: 10
    })



    const columnDef: ColDef<string[][]>[] = [
        {
            label: 'Id',
            renderItem: ({ item, index }) => item[index],
            hidden: true
        },
        {
            label: 'วันที่',
            width: "20%",
            renderItem: ({ item, index }) => item[index],
        },
        {
            label: 'รายละเอียด',
            width: "20%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'ลักษณะงาน',
            width: "20%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'ชม.',
            width: "20%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: '',
            renderItem: ({ item }) => <>
                <div className='text-center'>
                    <button
                        type='button'
                        onClick={(e) => {
                            const key = tableSetting.primaryKey(item)
                            navigate('/job-detail/' + key[0])
                        }
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3'
                        />
                    </button>


                </div>
            </>,
        },
    ]

    const footerDef: ColDef<string[][]>[] = [
        {
            label: 'วันที่',
            renderItem: ({ item, index }) => item[index],
        },
        {
            label: 'รายละเอียด',
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'ลักษณะงาน',
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'คะแนน',
            renderItem: ({ item, index }) => <div className='text-primary fw-bolder'>{item[index]}</div>
        },
        {
            label: '',
            renderItem: () => <></>,
        },
    ]

    const tableSetting: TableSetting<string[][]> = {
        showColAction: false,
        primaryKey: (item: string[][]) => item,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: false,
        showSearch: false,
        btnAddText: 'เพิ่ม ชม. Assignment',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/job-detail/new'),

    }

    useEffect(() => {
        const load = () => {
            if (lastSeason) {
                JobService.Search(searchParam).then((result) => {
                    const row = result.data.result
                    setTotalRow(row.totalRows)
                    setData(row.rows)
                    setFootData(row.footers)
                })

                JobService.Summary(searchParam)
                    .then((result) => {
                        const row = result.data.result
                        setSumData(row.rows)
                    })

            }
        }
        load()
    }, [lastSeason, searchParam, reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                <div className='card-header cursor-pointer'>

                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>

                </div>
                {/* begin::Body */}
                <div className='card-body py-3'>
                    <div className='table-responsive'>
                        <table className='table align-middle table-bordered fs-6 gy-5 dataTable'>
                            <thead>
                                <tr className='text-start fw-bolder fs-6 text-uppercase gs-0'>
                                    <td>รายการ</td>
                                    <td>SVNH</td>
                                    <td>Training</td>
                                    <td>Holistic</td>
                                    <td>สรุป ชม.</td>
                                </tr>
                            </thead>
                            <tbody>
                                {sumData.map((row, index) => {
                                    return <tr key={index}>
                                        <td>จำนวน ชม.</td>
                                        <td>{row[0]}</td>
                                        <td>{row[1]}</td>
                                        <td>{row[2]}</td>
                                        <td className='text-primary fw-bolder'>{row[3]}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>


                    {/* begin::Table container */}
                    <div >
                        <h2>ค้นหา</h2>
                        <div className='d-flex p-5'>
                            <div className='p-2'>วันที่เริ่มต้น</div>
                            <div className=''>

                                <ReactCalendar
                                    onChange={(values) => {
                                        setSearchParam({
                                            ...searchParam,
                                            startDate: values,
                                            page: 0
                                        })
                                    }}
                                    className='form-control form-control-solid'                                    
                                    value={searchParam.startDate}                                   
                                />
                            </div>
                        </div>
                        <div className='d-flex p-5'>
                            <div className='p-2'>วันที่สิ้นสุด</div>
                            <div className=''>

                                <ReactCalendar
                                    onChange={(values) => {
                                       
                                        setSearchParam({
                                            ...searchParam,
                                            endDate: values,
                                            page: 0
                                        })
                                    }}
                                    className='form-control form-control-solid'                                   
                                    value={searchParam.endDate}
                                   
                                />
                            </div>
                        </div>
                        {/* <div className='d-flex p-5'>
                            <button onClick={() =>{} } className='btn btn-light'>ค้นหา</button>
                           
                        </div> */}
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            footers={footerDef}
                            data={data as []}
                            dataFooter={footData as []}
                        />
                        {/* end::Table */}
                    </div>
                    <div>
                        <PaginationStd
                            pageSetting={{
                                currentPage: searchParam.page,
                                totalRow: totalRow,
                                pageSize: 10,
                            }}
                            onPageChange={(e: any, page: number) => setSearchParam({
                                ...searchParam,
                                page
                            })}
                            isLoading={false}
                        />
                    </div>
                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { JobPage }
